import screenbanner from "./image/background/1.jpg";
import mobilebanner from "./image/background/2.jpg";
import Dlf from "./image/developersImages/DLF.webp"
import Home1 from "./image/Location/home1.webp";
import Dwarika from "./image/Location/dwarika.png"
import GolfExtension from "./image/Location/golfcourseextention.png"
import golfcourse from "./image/Location/golfcourse.png"
import spr from "./image/Location/spr.png"


export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};
export const LocationData = {
  taglineheading: "Hot Localities in Gurugram",
  locationtag: "in Gurugram",
  location: [
    {
      title: "SPR Road",
      propertcount: 8,
      image: spr,
      link: `/gurugram/spr-road`,
    },
    {
      title: "Golf Course Road",
      propertcount: 5,
      image: golfcourse,
      link: `/gurugram/golf-course-road`,
    },
    {
      title: "Dwarka Expressway",
      propertcount: 10,
      image: Dwarika,
      link: `/gurugram/dwarka-expressway`,
    },
    {
      title: "Golf Course Extention Road",
      propertcount: 5,
      image: GolfExtension,
      link: `/gurugram/golf-course-extension-road`,
    },
  ],
};
